export class ColumnField {
    key: string;
    format: string;
    display: string;
    filterType: string;
    allowEmptyAggregation: boolean;

    constructor(key: string, format: string, display: string, allowEmptyAggregation = false, filterType = null) {
        this.key = key;
        this.format = format;
        this.display = display;
        this.filterType = filterType;
        this.allowEmptyAggregation = allowEmptyAggregation;
    }
}
